import {defineStore} from "pinia";
import {Ref} from "vue";
import {INewShift, IShift} from "@/features/shifts/shifts.types";
import {shiftService} from "@/features/shifts/shifts.service";
import {ITableHeader} from "@/types/table";

export const useShiftStore = defineStore("shift", () => {
    const shiftsForFilter: IShift[] = [];
    const shiftHeaders: ITableHeader[] = [
        {
            name: 'id',
            label: 'No',
            fitContent: true
        },
        {
            name: 'title',
            label: 'Shift name',
            width: '300px'
        },
        {
            name: 'start_time',
            label: 'Start',
            width: '300px'
        },
        {
            name: 'end_time',
            label: 'End'
        },
        {
            name: 'is_active',
            label: 'Status',
            width: '150px'
        },
        {
            name: 'actions',
            label: 'Actions',
            fitContent: true
        }
    ];


    async function getShifts(
        loading: Ref<boolean>,
        isActive?: boolean
    ): Promise<IShift[]> {
        try {
            loading.value = true
            const {data} = await shiftService.getShifts(isActive)
            return data
        } finally {
            loading.value = false
        }
    }

    async function getShiftById(
        loading: Ref<boolean>,
        id: string
    ): Promise<IShift> {
        try {
            loading.value = true
            const {data} = await shiftService.getShiftById(id)
            return data
        } finally {
            loading.value = false
        }
    }

    async function createShift(
        loading: Ref<boolean>,
        payload: INewShift
    ) {
        try {
            loading.value = true
            const {data} = await shiftService.createShift(payload)
            return data
        } finally {
            loading.value = false
        }
    }

    async function updateShift(
        loading: Ref<boolean>,
        payload: INewShift,
        id: string
    ) {
        try {
            loading.value = true
            const {data} = await shiftService.updateShift(id, payload)
            return data
        } finally {
            loading.value = false
        }
    }

    async function deleteShift(
        loading: Ref<boolean>,
        id: string
    ) {
        try {
            loading.value = true
            const {data} = await shiftService.deleteShift(id)
            return data
        } finally {
            loading.value = false
        }
    }

    return {
        shiftsForFilter,
        shiftHeaders,
        getShifts,
        getShiftById,
        createShift,
        updateShift,
        deleteShift
    };
});
